export default __webpack_public_path__ + "static/media/lucas-george-wendt-8CozIYUUJJ4-unsplash.2dd2872e.jpg";